import { RouteItem } from '../../routes/RouteItem';
import { ApplicationStep } from './RouteItem.types';
import { BusinessAddressPage } from '../pages/BusinessAddressPage';
import { BusinessDetailsPage } from '../pages/BusinessDetailsPage';
import { DepositAccountPage } from '../pages/DepositAccountPage';
import { IndustryCategoryPage } from '../pages/IndustryCategory';
import { PersonalAddressPage } from '../pages/PersonalAddressPage';
import { PersonalDetailsPage } from '../pages/PersonalDetailsPage';
import { SignupReasonPage } from '../pages/SignupReasonPage';
import { SellingFrequency } from '../pages/SellingFrequency';
import { ReviewFinalPage } from '../pages/ReviewFinalPage';
import { CongratulationsPage } from '../pages/CongratulationsPage';
import { WebsiteDetail } from '../pages/WebsiteDetail';

const signupReasonStep: RouteItem = {
  id: 'welcome',
  title: 'Welcome',
  path: '/app/signup-reason',
  component: SignupReasonPage,
};

const personalDetailsStep: ApplicationStep = {
  id: 'personalDetails',
  title: 'Personal Details',
  subSections: [
    {
      title: 'Personal Info',
      path: '/app/personal-info',
      component: PersonalDetailsPage,
    },
    {
      title: 'Address',
      path: '/app/personal-address',
      component: PersonalAddressPage,
    },
  ],
};

const businessDetailsStep: ApplicationStep = {
  id: 'businessDetails',
  title: 'Business Details',
  subSections: [
    {
      title: 'Business Info',
      path: '/app/business-info',
      component: BusinessDetailsPage,
    },
    {
      title: 'Address',
      path: '/app/business-address',
      component: BusinessAddressPage,
    },
  ],
};

const industryAndProcessingInfoStep: ApplicationStep = {
  id: 'industryAndProcessingInfo',
  title: 'Industry and Processing Info',
  subSections: [
    {
      title: 'Industry Category',
      path: '/app/industry-category',
      component: IndustryCategoryPage,
    },
    {
      title: 'Sales Info',
      path: '/app/sales-info',
      component: SellingFrequency,
    },
    {
      title: 'Website',
      hideFromProgressUi: true,
      path: '/app/business-website',
      component: WebsiteDetail,
    },
  ],
};

const bankingDetailsStep: ApplicationStep = {
  id: 'bankingDetails',
  title: 'Banking Details',
  subSections: [
    {
      title: 'Deposit Account',
      path: '/app/deposit-account',
      component: DepositAccountPage,
    },
  ],
};

const submitStep: ApplicationStep = {
  id: 'submit',
  title: 'Submit',
  subSections: [
    {
      title: 'Review',
      path: '/app/review',
      component: ReviewFinalPage,
    },
    {
      title: '', // purposeful, don't want to show in the progress tracker
      path: '/app/complete',
      component: CongratulationsPage,
    },
  ],
};

export const applicationSteps = {
  signupReasonStep,
  personalDetailsStep,
  businessDetailsStep,
  industryAndProcessingInfoStep,
  bankingDetailsStep,
  submitStep,
};

export const routes = Object.keys(applicationSteps).reduce((acc, key) => {
  const step: RouteItem | ApplicationStep = applicationSteps[key];
  acc.push(
    ...(step.subSections || []).map((subSection, index) => ({
      ...subSection,
      id: `${step.id}.${index}`,
    })),
  );
  // the parent of 'subSections' doesn't have to be a route, it can just contain sub routes
  if ((step as RouteItem).component) {
    acc.push(step as RouteItem);
  }
  return acc;
}, [] as RouteItem[]);
